export enum ERROR_CODE {
  NETWORK_ERROR = '50001',
  EMPTY_DATA = '50002',
}
